import { render, staticRenderFns } from "./VehicleConfig.vue?vue&type=template&id=1de52407&scoped=true"
import script from "./VehicleConfig.vue?vue&type=script&lang=js"
export * from "./VehicleConfig.vue?vue&type=script&lang=js"
import style0 from "./VehicleConfig.vue?vue&type=style&index=0&id=1de52407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de52407",
  null
  
)

export default component.exports